import { HandCardState } from '@/types/game';

export interface HandCardView {
  ownerId: string;
  isOwner: boolean;
  isRevealedToOthers: boolean;
  showFrontFace: boolean;
  displayImageUrl: string | null;
  backImageUrl?: string;
  isSelectedByViewer: boolean;
  isSelectedByOthers: boolean;
  selectedBy: string[];
  otherSelectors: string[];
}

const DEFAULT_VIEWER_ID = 'local';

/**
 * Compute the perspective-aware view of a hand card for a specific viewer.
 */
export function getHandCardView(card: HandCardState, viewerId?: string | null): HandCardView {
  const normalizedViewerId = viewerId ?? DEFAULT_VIEWER_ID;
  const rawOwnerId = card.owner ?? normalizedViewerId;
  const ownerId =
    rawOwnerId === DEFAULT_VIEWER_ID && normalizedViewerId !== DEFAULT_VIEWER_ID
      ? normalizedViewerId
      : rawOwnerId;

  const isOwner = ownerId === normalizedViewerId;
  const isRevealed = Boolean(card.isRevealedToOthers);
  const selectedBy = card.selectedBy ?? [];
  const otherSelectors = selectedBy.filter(id => id !== normalizedViewerId);

  const showFrontFace = isOwner ? !isRevealed : isRevealed;
  const displayImageUrl = showFrontFace
    ? card.imageUrl ?? null
    : card.backImageUrl ?? card.imageUrl ?? null;

  return {
    ownerId,
    isOwner,
    isRevealedToOthers: isRevealed,
    showFrontFace,
    displayImageUrl,
    backImageUrl: card.backImageUrl,
    isSelectedByViewer: selectedBy.includes(normalizedViewerId),
    isSelectedByOthers: otherSelectors.length > 0,
    selectedBy,
    otherSelectors
  };
}
